<template>
  <v-app id="app">
    <router-view :key="$route.fullPath" />
  </v-app>
</template>

<script>
export default {
  name: 'app',
  data: function() {
    return {}
  },
  watch: {
    $route(to, from) {
      window.scrollTo({
        top: 0,
      })
    },
  },
}
</script>

<style lang="scss">
* {
  user-select: none;
  -webkit-touch-callout: none;
  touch-action: pan-x pan-y;
}
input,
textarea {
  user-select: auto;
  &:focus {
    outline: none;
  }
}
#app {
  font-family: 'SF Pro Display', 'Roboto', 'Ping Fang TC', 'Ping Fang TC', Arial,
    Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #4a4a4a;
}

body {
  margin: 0px;
  background-color: #f3f5f8;
  box-sizing: border-box;
  overflow-x: hidden;
  video,
  object,
  iframe,
  table,
  embed {
    width: 100% !important;
    height: auto !important;
  }
}

a {
  text-decoration: none;
}

.container {
  background-color: #f3f3f3;
}

.h3 {
  font-size: 18px;
}

.h4 {
  font-size: 15px;
}

.h6 {
  font-size: 13px;
}

/* Rewrites Form Elements */
.v-application {
  .v-btn:not(.v-btn--round) {
    border-radius: 10px;
  }
  .v-application--wrap {
    min-height: calc(100vh - 49px) !important;
  }
  .theme--light.v-label {
    font-size: 14px;
    color: #545454;
  }
  .theme--light.v-icon {
    color: #9b9b9b;
  }
  .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #ededed;
  }
  .theme--light {
    &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #8bd0fb !important;
      color: #fff !important;
    }
  }
  .v-input {
    padding-top: 16px;
    .v-messages {
      height: 17px;
    }
    .v-label.v-label--active {
      transform: translateY(-22px) scale(0.8);
    }
  }
  .v-select {
    .v-input__icon {
      .v-icon {
        font-size: 18px;
      }
    }

    &--no-label {
      padding-top: 0;
      .v-label {
        color: #9b9b9b;
      }
      &.v-input--is-label-active,
      &.v-input--is-focused {
        .v-label {
          display: none;
        }
      }
    }
    .v-select__slot {
      .v-label {
        font-size: 12px;
        color: #767676 !important;
      }
    }
  }
  .v-input--selection-controls__input {
    margin-right: 12px;
  }
  .v-input--selection-controls__ripple:before {
    opacity: 0 !important;
  }
  .v-input--checkbox {
    .v-icon {
      border: 1px #dedede solid;
      width: 22px;
      height: 22px;
      font-size: 22px;
      border-radius: 6px;
    }

    &.v-input--is-label-active {
      .v-icon {
        border: none;
        background: radial-gradient(circle, #fff 40%, #1da7fc 41%) !important;
      }
    }

    &:not(.v-input--hide-details) .v-input__slot {
      margin-bottom: 0;
    }
  }

  .v-text-field {
    margin-top: 8px;

    &--no-label {
      padding-top: 0;
    }

    .v-text-field__slot {
      label {
        color: #9b9b9b !important;
      }
      input {
        font-size: 12px;
        color: #767676 !important;
      }
    }
    &.v-input--is-dirty {
      .v-text-field__slot input {
        font-size: 16px;
        color: #383838 !important;
      }
    }
    .v-input__slot {
      margin-bottom: 4px;
    }
  }

  .v-input--radio-group {
    padding-top: 0;
    &:not(.v-input--hide-details) .v-input__slot {
      margin-bottom: 0px;
    }
    .v-messages {
      margin-top: -8px;
      margin-bottom: 2px;
    }
    .v-radio {
      .v-icon {
        border: 1px #dedede solid;
        width: 24px;
        height: 24px;
        font-size: 28px;
        border-radius: 100%;

        &:before {
          content: '';
        }

        &.v-input--is-label-active {
          .v-icon {
            border: none;
          }
        }

        &.accent--text {
          &:before {
            content: '';
            width: 12px;
            height: 12px;
            border-radius: 100%;
            background-color: #f22803;
          }
        }
      }
      .v-label {
        &.theme--light {
          font-size: 14px;
          color: #545454;
        }
      }
      &.v-item--active {
        .v-icon {
          font-size: 0 !important;
          background: radial-gradient(circle, #1da7fc 44%, #ffffff 48%);
        }
      }
    }
  }
  .v-btn-primary {
    width: 100%;
    border-radius: 5px;
    box-shadow: none;

    &:active {
      box-shadow: none;
    }

    &.v-btn:not(.v-btn--round) {
      height: 46px;
    }

    .v-ripple__container {
      box-shadow: none;
    }

    .v-btn__content {
      color: white;
      letter-spacing: normal;
      font-size: 16px;
    }
    &.v-btn--outlined .v-btn__content {
      color: #1da7fc;
    }

    &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #8bd0fb !important;
      color: #fff !important;
    }
  }
}

.ads-carousel {
  .swiper-pagination {
    bottom: 1.1em;

    .item-inactive.item-active {
      opacity: 1;
      background-color: white;
    }
    .item-inactive {
      opacity: 1;
      margin: 0 0.1em;
      width: 1em;
      height: 0.3em;
      display: inline-block;
      background-color: #d4d0c8;
    }
  }
}

.v-menu__content,
.v-list {
  background-color: #fff;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    border-left: 10px solid white;
    border-right: 2px solid white;
    background-color: #ededed;
  }
}
</style>
